import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { AttendanceCell, CELL_STYLES } from "../admin/attendance/AttendanceCell";

const LEGEND = [["present", "Present"], ["half_day", "Half day"], ["absent", "Absent"], ["leave", "Leave"], ["holiday", "Holiday"], ["weekoff", "Week off"]];

export const MyCalendar = ({ userId, month }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!userId || !month) return;
    api.get(`/attendance/calendar/${userId}`, { params: { month } }).then((r) => setData(r.data)).catch(() => setData(null));
  }, [userId, month]);

  if (!data) return null;
  const leadingBlanks = (new Date(data.days[0].date + "T00:00:00").getDay() + 6) % 7;

  return (
    <div className="bg-white border border-stone-200 rounded-2xl p-4 space-y-4" data-testid="my-attendance-calendar">
      <div className="flex flex-wrap gap-2 text-xs" data-testid="my-calendar-summary">
        <span className="px-2.5 py-1 rounded-full bg-green-50 text-green-700 font-bold tabular-nums">{data.summary.present} present</span>
        {data.summary.half_day > 0 && <span className="px-2.5 py-1 rounded-full bg-purple-50 text-purple-700 font-bold tabular-nums">{data.summary.half_day} half day</span>}
        <span className="px-2.5 py-1 rounded-full bg-red-50 text-red-700 font-bold tabular-nums">{data.summary.absent} absent</span>
        <span className="px-2.5 py-1 rounded-full bg-amber-50 text-amber-700 font-bold tabular-nums">{data.summary.leave} leave</span>
        <span className="px-2.5 py-1 rounded-full bg-blue-50 text-blue-700 font-bold tabular-nums">{data.summary.holiday} holiday</span>
      </div>

      <div className="grid grid-cols-7 gap-1.5" data-testid="my-calendar-grid">
        {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((d) => (
          <div key={d} className="text-center text-[11px] font-bold uppercase tracking-wide text-stone-400 py-1">{d[0]}</div>
        ))}
        {Array.from({ length: leadingBlanks }).map((_, i) => <div key={`blank-${i}`} />)}
        {data.days.map((d) => <AttendanceCell key={d.date} day={d} />)}
      </div>

      <div className="flex flex-wrap gap-3 pt-1">
        {LEGEND.map(([k, label]) => (
          <span key={k} className="flex items-center gap-1.5 text-xs text-stone-500">
            <span className={`w-3.5 h-3.5 rounded ${CELL_STYLES[k].split(" ")[0]}`} /> {label}
          </span>
        ))}
      </div>
    </div>
  );
};
